import { apiClient } from "@apis/apiClient";


/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  findAll(deviceId: any, params: any) {
    return apiClient.post(`/rest/orientationstates/${deviceId}`, params, {
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    });
  },
  // STIC-16316: runs the tracker's own orientation script on a sample orientation
  test(params: any) {
    return apiClient.post(`/rest/orientationstates/test`, params, {
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    });
  },

  getOrientationStates() {
    return apiClient.get(`/rest/orientationstates/orientationStates`);
  },

  getOrientationStateAll() {
    return apiClient.get(`/rest/orientationstates/all/orientationStates`);
  },

  getOrientationStateOptions(includeDefault: boolean, orgId?: number | null) {
    return apiClient.get(`/rest/orientationstates/options`, {
      params: { includeDefault, ...(orgId != null ? { org: orgId } : {}) },
    });
  },

  getOrientationForChart(deviceId: any, params: any) {
    return apiClient.post(`/rest/orientationstates/chart/${deviceId}`, params, {
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    });
  },
};
